import {
	Tooltip,
	TooltipContent,
	TooltipTrigger
} from "~/components/ui/tooltip"
import { useState } from "react"
import { ChevronDownIcon } from "lucide-react"
import { Button } from "~/components/ui/button"
import {
	Popover,
	PopoverContent,
	PopoverTrigger
} from "~/components/ui/popover"
import {
	Command,
	CommandInput,
	CommandList,
	CommandGroup,
	CommandItem,
	CommandEmpty
} from "~/components/ui/command"
import { KBIcon, kbIcons } from "./KBIcon"

export function KBIconPicker({
	value,
	onChange,
	disabled
}: {
	value: string
	onChange: (value: string) => void
	disabled?: boolean
}) {
	const [open, setOpen] = useState(false)
	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					variant="picker-outline"
					role="combobox"
					aria-label="Document icon"
					aria-expanded={open}
					disabled={disabled}
				>
					<KBIcon name={value} className="size-4 shrink-0" />
					<ChevronDownIcon className="ml-auto size-4 shrink-0" />
				</Button>
			</PopoverTrigger>
			<PopoverContent size="lg">
				<Command>
					<CommandInput placeholder="Search icons…" />
					<CommandList>
						<CommandEmpty>No icons found</CommandEmpty>
						<CommandGroup layout="icons">
							{Object.entries(kbIcons).map(([name, Icon]) => (
								<Tooltip key={name}>
									<TooltipTrigger asChild>
										<CommandItem
											variant="icon"
											data-chosen={value === name}
											aria-label={name.replace(/([a-z])([A-Z])/g, "$1 $2")}
											value={name}
											keywords={[name.replace(/([a-z])([A-Z])/g, "$1 $2")]}
											onSelect={() => {
												onChange(name)
												setOpen(false)
											}}
										>
											<Icon className="size-4 shrink-0" />
										</CommandItem>
									</TooltipTrigger>
									<TooltipContent>
										{name.replace(/([a-z])([A-Z])/g, "$1 $2")}
									</TooltipContent>
								</Tooltip>
							))}
						</CommandGroup>
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	)
}
